import React, { useCallback, useEffect, useRef, useState, } from 'react';
import { Spinner } from '@nykaa/ui-components/Loader';
import IoElement from '../IOElement';
import AnchorTag from '../AnchorTag';
import Wrapper from '../../layouts/ImageVideoWrapper';
import useScaleUrl from '../../hooks/ScaleUrl';
const BANNER_IMAGE = 'banner image';
const Video = (widgetData) => {
    var _a;
    const videoRef = useRef(null);
    const { params, isDesktop, isServer, trackingData, handleVideo, outlineRef, remoteConfigs, } = widgetData;
    const { url, src, thumbnail, columnsInRow, } = params;
    const [loader, setLoader] = useState(true);
    const { scaleUrl: scaleThumbnail } = useScaleUrl(thumbnail, isDesktop, columnsInRow, (_a = remoteConfigs === null || remoteConfigs === void 0 ? void 0 : remoteConfigs.switches) === null || _a === void 0 ? void 0 : _a.optimizedImageUrlEnabled);
    useEffect(() => {
        if (loader && videoRef.current.readyState >= 3) {
            setLoader(false);
        }
    }, [loader, videoRef]);
    const handlePlay = useCallback(() => {
        var _a;
        /**
         * @abstract this is used to reset the video if its coming back into the view port
         */
        // if (video.current.paused && video.current.currentTime > 0) {
        //   video.current.currentTime = '0.01';
        // }
        if (videoRef.current.readyState >= 3) {
            (_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.play();
        }
    }, [videoRef]);
    const handleEmptyIntersect = () => {
    }; // this is need we need only one intersect at a time.
    const handlePause = () => {
        if (videoRef.current.currentTime > 0) {
            videoRef.current.pause();
        }
    };
    // const handleError = () => {
    //   setShowThumbnail(true);
    // };
    const handleVideoClick = () => {
        const videoRefs = videoRef === null || videoRef === void 0 ? void 0 : videoRef.current;
        if (!videoRef) {
            return;
        }
        handleVideo(videoRefs.duration, videoRefs.currentTime);
    };
    const { namespace2 } = trackingData;
    const altText = namespace2 || BANNER_IMAGE;
    return (React.createElement(IoElement, { onIntersect: handleEmptyIntersect, onIntersectV2: handlePlay, isServer: isServer, exitCallBack: handlePause },
        React.createElement(Wrapper, { className: "image-wrapper", params: params, isDesktop: isDesktop },
            React.createElement(AnchorTag, { url: url },
                React.createElement("div", { ref: outlineRef, onClick: handleVideoClick },
                    loader && (React.createElement("div", { key: widgetData === null || widgetData === void 0 ? void 0 : widgetData.id, className: "video-loader" },
                        React.createElement(Spinner, { indeterminateTime: 1, size: "large", value: 0 }))),
                    React.createElement("video", { poster: scaleThumbnail, ref: videoRef, loop: true, autoPlay: true, muted: true, playsInline: true, onCanPlay: () => setLoader(false) },
                        React.createElement("source", { src: src, type: "video/mp4" }),
                        React.createElement("img", { alt: altText, src: scaleThumbnail, loading: "eager" })))))));
};
export default Video;
